import { JetpacB2BApi } from 'api' // NOTE: Assuming a B2B-specific API client exists. Please replace with the correct one.

class B2bCommonApi {
  static async getCountryList(faberToken: string) {
    return JetpacB2BApi.httpGet(
      `common/country`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
  static async getCityList(faberToken: string,countryCode:string) {
    return JetpacB2BApi.httpGet(
      `common/city?country_code=${countryCode}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
}

export default B2bCommonApi
